/*
 *
 * Do not edit directly
 * Generated on Thu, 20 Apr 2023 19:04:54 GMT
 *
 */

const PaletteIconChevronRight = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/ChevronRight')
const PaletteIconMobileCheckmark = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/MobileCheckmark')
const PaletteIconChevronLeft = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/ChevronLeft')
const PaletteIconArrowRight = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/ArrowRight')
const PaletteIconArrowLeft = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/ArrowLeft')
const PaletteIconCheckMark = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/CheckMark')
const PaletteIconError = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/Error')
const PaletteIconClose = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/Close')
const PaletteIconMobileXClose = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/MobileXClose')
const PaletteIconWarningError = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/WarningError')
const PaletteIconChevronDown = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/ChevronDown')
const PaletteIconInfo = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/Info')
const PaletteIconEyeUnmasked = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/EyeUnmasked')
const PaletteIconEyeMasked = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/EyeMasked')
const PaletteIconXMark = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/XMark')
const PaletteIconHelp = require('@telus-uds/palettes-community.palette-public-mobile-rebrand/build/rn/icons/Help')

module.exports = {
  components: {
    ActivityIndicator: {
      appearances: {
        size: {
          description: 'used for full-screen spinners',
          type: 'variant',
          values: [ 'small' ]
        }
      },
      rules: [ { if: { size: 'small' }, tokens: { size: 40, thickness: 4 } } ],
      tokens: { color: '#394056', size: 48, thickness: 4 }
    },
    Badge: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        outline: { type: 'variant', values: [ true ] },
        purpose: { type: 'variant', values: [ 'offer', 'editorial' ] }
      },
      rules: [
        {
          if: { alternative: true },
          tokens: {
            backgroundColor: '#eaf3f1',
            borderColor: '#eaf3f1',
            color: '#2b826e'
          }
        },
        {
          if: { outline: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#f9f2dd'
          }
        },
        {
          if: { purpose: 'offer' },
          tokens: { backgroundColor: '#fce6df', borderColor: '#fce6df' }
        },
        {
          if: { purpose: 'editorial' },
          tokens: { backgroundColor: '#cdcfd5', borderColor: '#cdcfd5' }
        },
        {
          if: { outline: true, purpose: 'editorial' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#cdcfd5'
          }
        },
        {
          if: { outline: true, purpose: 'offer' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#fce6df',
            borderWidth: 2,
            color: '#394056'
          }
        }
      ],
      tokens: {
        backgroundColor: '#f9f2dd',
        borderColor: '#f9f2dd',
        borderRadius: 999,
        borderWidth: 2,
        color: '#394056',
        fontName: 'SofiaPro',
        fontWeight: '400',
        gradient: null,
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2
      }
    },
    Box: {
      appearances: {
        background: {
          description: 'Background colour of box. No background color if not specified',
          type: 'variant',
          values: [
            'lightest',         'lighter',
            'light',            'dark',
            'darker',           'darkest',
            'critical',         'danger',
            'warning',          'positive',
            'brand',            'white',
            'black',            'featurePrimary',
            'featureSecondary', 'featureNeutral',
            'featureBrand'
          ]
        }
      },
      rules: [
        {
          if: { background: 'lightest' },
          tokens: { backgroundColor: '#fefefc' }
        },
        {
          if: { background: 'lighter' },
          tokens: { backgroundColor: '#fdfcf6' }
        },
        {
          if: { background: 'light' },
          tokens: { backgroundColor: '#fcf8ee' }
        },
        {
          if: { background: 'dark' },
          tokens: { backgroundColor: '#6a7080' }
        },
        {
          if: { background: 'darker' },
          tokens: { backgroundColor: '#394056' }
        },
        {
          if: { background: 'darkest' },
          tokens: { backgroundColor: '#2b3145' }
        },
        {
          if: { background: 'critical' },
          tokens: { backgroundColor: '#bf1722' }
        },
        {
          if: { background: 'danger' },
          tokens: { backgroundColor: '#f9e8e9' }
        },
        {
          if: { background: 'warning' },
          tokens: { backgroundColor: '#fcf8ee' }
        },
        {
          if: { background: 'positive' },
          tokens: { backgroundColor: '#eaf3f1' }
        },
        {
          if: { background: 'brand' },
          tokens: { backgroundColor: '#394056' }
        },
        {
          if: { background: 'white' },
          tokens: { backgroundColor: '#ffffff' }
        },
        {
          if: { background: 'black' },
          tokens: { backgroundColor: '#2b3145' }
        },
        {
          if: { background: 'featurePrimary' },
          tokens: { backgroundColor: '#f6b5a0' }
        },
        {
          if: { background: 'featureSecondary' },
          tokens: { backgroundColor: '#f9cebf' }
        },
        {
          if: { background: 'featureNeutral' },
          tokens: { backgroundColor: '#fce6df' }
        },
        {
          if: { background: 'featureBrand' },
          tokens: { backgroundColor: '#f39d80' }
        }
      ],
      tokens: { backgroundColor: null, gradient: null }
    },
    Breadcrumbs: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [ { if: { inverse: true }, tokens: { iconColor: null } } ],
      tokens: {
        icon: PaletteIconChevronRight,
        iconColor: null,
        iconPadding: 8,
        listItemPadding: 0
      }
    },
    Button: {
      appearances: {
        danger: {
          description: 'Indicates a user action that is destructive and will result in loss of information or cause significant monetary charges. Limit the use of the danger button whenever possible.',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'Use inverse buttons on darker backgrounds. High and low priority buttons, and danger buttons, are available in inverse.',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        },
        priority: {
          description: 'Indicates the importance of the call-to-action. Limit the amount of high priority buttons on a page to prioritize meaningful user flows. Low priority styles are applied by default.',
          type: 'variant',
          values: [ 'high', 'low' ]
        },
        size: { type: 'variant', values: [ 'small' ] },
        text: {
          description: 'Text variant visually deprioritize the button styles',
          type: 'variant',
          values: [ true ]
        },
        width: {
          description: 'Available in default or full-width. Default-width expands based on content Full-width expands to width of the container.',
          type: 'variant',
          values: [ 'full' ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#2b3145' } },
        {
          if: { priority: 'high' },
          tokens: {
            backgroundColor: '#f39d80',
            borderColor: '#636c8c',
            color: '#394056'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#636c8c',
            borderColor: '#636c8c',
            color: '#fefefc'
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#f39d80', outerBorderWidth: 4 }
        },
        {
          if: { inverse: true },
          tokens: { backgroundColor: '#fefefc', borderColor: '#fefefc' }
        },
        {
          if: { hover: true, priority: 'high' },
          tokens: {
            backgroundColor: '#f6b5a0',
            borderColor: '#636c8c',
            color: '#394056'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            backgroundColor: '#636c8c',
            borderColor: '#f39d80',
            color: '#fefefc',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        {
          if: { inverse: true, priority: 'high' },
          tokens: { backgroundColor: '#f9f2dd', borderColor: '#f9f2dd' }
        },
        {
          if: { hover: true, inverse: true, priority: 'high' },
          tokens: { backgroundColor: '#fcf8ee', borderColor: '#fcf8ee' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#fdfcf6',
            borderColor: '#394056',
            color: '#394056'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            backgroundColor: '#fefefc',
            borderColor: '#394056',
            color: '#394056',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        {
          if: { danger: true, priority: null },
          tokens: { borderColor: '#bf1722', color: '#bf1722' }
        },
        {
          if: { danger: true, inverse: true, priority: null },
          tokens: {
            backgroundColor: '#fefefc',
            borderColor: '#bf1722',
            color: '#bf1722'
          }
        },
        {
          if: { danger: true, focus: true, priority: null },
          tokens: {
            backgroundColor: '#fefefc',
            borderColor: '#bf1722',
            color: '#bf1722',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        {
          if: { danger: true, pressed: true, priority: null },
          tokens: {
            backgroundColor: '#bf1722',
            borderColor: '#bf1722',
            color: '#fefefc'
          }
        },
        {
          if: { danger: true, focus: true, pressed: true, priority: null },
          tokens: {
            backgroundColor: '#bf1722',
            borderColor: '#bf1722',
            color: '#fefefc',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        { if: { width: 'full' }, tokens: { width: '100%' } },
        {
          if: { size: 'small' },
          tokens: { paddingBottom: 4, paddingTop: 4 }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#9c9faa',
            borderColor: '#f5f5f7',
            color: '#cdcfd5'
          }
        },
        {
          if: { inactive: true, inverse: true },
          tokens: {
            backgroundColor: '#f5f5f7',
            borderColor: '#9c9faa',
            color: '#cdcfd5'
          }
        },
        {
          if: { text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            color: '#636c8c',
            minWidth: 0,
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            paddingLeft: 4,
            paddingRight: 4,
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, text: true },
          tokens: { textLine: 'none' }
        },
        {
          if: { priority: 'high', text: true },
          tokens: { color: '#636c8c' }
        },
        {
          if: { priority: 'low', text: true },
          tokens: { color: '#394056' }
        },
        {
          if: { focus: true, text: true },
          tokens: {
            color: '#636c8c',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 2
          }
        },
        {
          if: { hover: true, priority: 'high', text: true },
          tokens: { color: '#394056' }
        },
        {
          if: { hover: true, priority: null, text: true },
          tokens: { color: '#636c8c' }
        },
        {
          if: { hover: true, priority: 'low', text: true },
          tokens: { color: '#636c8c' }
        },
        {
          if: { danger: true, hover: true, text: true },
          tokens: { color: '#394056' }
        },
        {
          if: { pressed: true, text: true },
          tokens: { color: '#2b3145' }
        },
        {
          if: { focus: true, pressed: true, text: true },
          tokens: {
            color: '#2b3145',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        {
          if: { inactive: true, text: true },
          tokens: { color: '#cdcfd5' }
        },
        {
          if: { inverse: true, text: true },
          tokens: { color: '#f9f2dd' }
        },
        {
          if: { focus: true, inverse: true, text: true },
          tokens: {
            color: '#f9f2dd',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 4
          }
        },
        {
          if: { focus: true, inverse: true, pressed: true, text: true },
          tokens: {
            color: '#f9f2dd',
            outerBorderColor: '#f9f2dd',
            outerBorderWidth: 2
          }
        },
        {
          if: { inactive: true, inverse: true, text: true },
          tokens: { color: '#cdcfd5' }
        },
        {
          if: { pressed: true, priority: 'high' },
          tokens: {
            backgroundColor: '#fce6df',
            borderColor: '#636c8c',
            color: '#394056'
          }
        },
        {
          if: { focus: true, priority: 'high' },
          tokens: { outerBorderColor: '#f9cebf', outerBorderWidth: 4 }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { backgroundColor: '#fcf8ee', borderColor: '#fcf8ee' }
        },
        {
          if: { danger: true },
          tokens: {
            backgroundColor: '#fefefc',
            borderColor: '#bf1722',
            color: '#bf1722'
          }
        },
        {
          if: { danger: true, hover: true },
          tokens: {
            backgroundColor: '#f9e8e9',
            borderColor: '#bf1722',
            color: '#bf1722'
          }
        },
        {
          if: { danger: true, inverse: true },
          tokens: {
            backgroundColor: '#fefefc',
            borderColor: '#bf1722',
            color: '#bf1722'
          }
        },
        {
          if: { inactive: true, inverse: true, priority: 'high' },
          tokens: {
            backgroundColor: '#f9f2dd',
            borderColor: '#f9f2dd',
            color: '#394056'
          }
        },
        {
          if: { size: 'small', text: true },
          tokens: { fontSize: 16, lineHeight: 1.5 }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#394056',
        borderColor: '#394056',
        borderRadius: 8,
        borderWidth: 1,
        color: '#f39d80',
        fontName: 'SofiaPro',
        fontSize: 18,
        fontWeight: '400',
        icon: null,
        iconSize: 24,
        iconSpace: 2,
        lineHeight: 1.55555555,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: '#ffffff',
        outerBorderGap: 0,
        outerBorderWidth: 2,
        paddingBottom: 10,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 10,
        shadow: null,
        textAlign: 'center',
        textLine: 'none',
        textLineStyle: 'solid',
        width: null
      }
    },
    Callout: {
      appearances: { size: { type: 'variant', values: [ 'small' ] } },
      rules: [
        {
          if: { size: 'small' },
          tokens: { paddingBottom: 4, paddingTop: 4 }
        }
      ],
      tokens: {
        background: '#fce6df',
        borderRadius: 4,
        color: '#f39d80',
        gap: 16,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8
      }
    },
    Card: {
      appearances: {
        background: {
          type: 'variant',
          values: [ 'alternative', 'subtle', 'grid', 'image', 'feature' ]
        },
        padding: {
          type: 'variant',
          values: [ 'narrow', 'intermediate', 'compact', 'custom' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { background: 'alternative' },
          tokens: { backgroundColor: '#fcf8ee', borderColor: '#cdcfd5' }
        },
        {
          if: { background: 'subtle' },
          tokens: { backgroundColor: '#fdfcf6', borderColor: '#f9f2dd' }
        },
        {
          if: { background: 'grid' },
          tokens: { backgroundColor: '#fcf8ee', borderWidth: 0 }
        },
        {
          if: { background: 'image' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#cdcfd5' }
        },
        {
          if: { background: 'feature' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#f39d80' }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 48,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 48
          }
        },
        {
          if: { padding: 'narrow' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 24
          }
        },
        {
          if: { padding: 'narrow', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 32
          }
        },
        {
          if: { padding: 'intermediate' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { padding: 'intermediate', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 32
          }
        },
        {
          if: { padding: 'compact' },
          tokens: {
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        },
        {
          if: { padding: 'custom' },
          tokens: {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#cdcfd5',
        borderRadius: 4,
        borderWidth: 1,
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 0,
        contentJustifyContent: 'flex-start',
        flex: 1,
        minWidth: null,
        paddingBottom: 32,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 32,
        shadow: null
      }
    },
    Checkbox: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { error: true },
          tokens: { inputBorderColor: '#bf1722' }
        },
        {
          if: { focus: true },
          tokens: { inputOutlineColor: '#f39d80', inputOutlineWidth: 2 }
        },
        {
          if: { inactive: true },
          tokens: {
            iconBackgroundColor: '#cdcfd5',
            iconColor: '#9c9faa',
            inputBackgroundColor: '#cdcfd5',
            inputBorderColor: '#9c9faa'
          }
        },
        {
          if: { hover: true },
          tokens: { inputBackgroundColor: '#d8dae2' }
        },
        {
          if: { checked: true, focus: true },
          tokens: {
            inputBorderColor: '#394056',
            inputBorderWidth: 2,
            inputOutlineColor: '#f39d80',
            inputOutlineWidth: 3
          }
        }
      ],
      tokens: {
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        feedbackMarginBottom: 0,
        feedbackMarginTop: 2,
        feedbackPosition: 'bottom',
        icon: PaletteIconMobileCheckmark,
        iconBackgroundColor: '#394056',
        iconColor: '#ffffff',
        iconSize: 16,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#394056',
        inputBorderRadius: 4,
        inputBorderWidth: 2,
        inputHeight: 20,
        inputOutlineColor: null,
        inputOutlineWidth: 0,
        inputShadow: null,
        inputWidth: 20,
        labelColor: '#394056',
        labelFontName: 'SofiaPro',
        labelFontSize: 18,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 10
      }
    },
    CheckboxGroup: { appearances: {}, rules: [], tokens: { fieldSpace: 2, space: 2 } },
    ChevronLink: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        },
        size: {
          description: 'Sets the size of the text and icon; these variants are shared with ChevronLink',
          type: 'variant',
          values: [ 'large', 'small', 'micro' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { color: '#394056', iconDisplace: 4 }
        },
        { if: { pressed: true }, tokens: { color: '#2b3145' } },
        {
          if: { focus: true },
          tokens: { color: '#636c8c', outerBorderColor: '#636c8c' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#394056', outerBorderColor: '#394056' }
        },
        { if: { alternative: true }, tokens: { color: '#394056' } },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#636c8c' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#2b3145' }
        },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#394056', outerBorderColor: '#394056' }
        },
        {
          if: { alternative: true, focus: true, pressed: true },
          tokens: { color: '#2b3145', outerBorderColor: '#2b3145' }
        },
        { if: { inverse: true }, tokens: { color: '#f9f2dd' } },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#f9cebf' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#f39d80' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { color: '#f9f2dd', outerBorderColor: '#f9f2dd' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { color: '#f39d80', outerBorderColor: '#f39d80' }
        },
        {
          if: { size: 'large' },
          tokens: { height: 48, iconSize: 24, textLineHeight: 2 }
        },
        {
          if: { size: 'small' },
          tokens: { height: 36, iconSize: 20, textLineHeight: 1.9 }
        },
        {
          if: { size: 'micro' },
          tokens: { height: 32, iconSize: 16, textLineHeight: 1.85 }
        }
      ],
      tokens: {
        color: '#636c8c',
        height: 40,
        iconDisplace: 0,
        iconSize: 24,
        iconSpace: 1,
        leftIcon: PaletteIconChevronLeft,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        rightIcon: PaletteIconChevronRight,
        textLine: 'none',
        textLineHeight: 1.6
      }
    },
    DatePicker: {
      appearances: {},
      rules: [],
      tokens: {
        calendarDayBlockedCalendarHoverBackground: null,
        calendarDayBlockedCalendarHoverColor: null,
        calendarDayDefaultBeforeHeight: 24,
        calendarDayDefaultBeforeWidth: 24,
        calendarDayDefaultBorder: 1,
        calendarDayDefaultBorderColor: null,
        calendarDayDefaultCalendarDaySelectedHoverBackground: null,
        calendarDayDefaultCalendarDaySelectedHoverColor: null,
        calendarDayDefaultColor: null,
        calendarDayDefaultFontName: 'SofiaPro',
        calendarDayDefaultFontSize: 14,
        calendarDayDefaultFontWeight: '400',
        calendarDaySelectedHoverBeforeBackground: null,
        calendarDaySelectedHoverBorderColor: null,
        calendarDaySelectedHoverColor: null,
        calendarMonthCaptionColor: null,
        calendarMonthCaptionFontName: 'SofiaPro',
        calendarMonthCaptionFontSize: 20,
        calendarMonthCaptionFontWeight: '400',
        calendarMonthCaptionLineHeight: 1.43,
        calendarMonthCaptionPaddingBottom: 48,
        dateInputBorderColor: 'rgba(0, 0, 0, 0)',
        dateInputBorderRadius: 4,
        dateInputFocusBorderColor: null,
        dateInputHoverBorderColor: null,
        dateInputInsideBorderColor: null,
        dateInputInsideColor: null,
        dateInputStrokeColor: null,
        dayPickerNavigationButtonBackgroundColor: null,
        dayPickerNavigationButtonBorderColor: null,
        dayPickerNavigationButtonChildLeft: 8,
        dayPickerNavigationButtonChildRight: 8,
        dayPickerNavigationButtonChildSvgFill: null,
        dayPickerNavigationButtonDefaultHoverBorderColor: null,
        dayPickerNavigationButtonMaxHeight: 32,
        dayPickerNavigationButtonMaxWidth: 32,
        dayPickerNavigationButtonPadding: 8,
        dayPickerNavigationSVGHorizontalFill: null,
        dayPickerWeekHeaderColor: null,
        dayPickerWeekHeaderFontName: 'SofiaPro',
        dayPickerWeekHeaderFontWeight: '400',
        dayPickerWeekHeaderLineHeight: 1.428,
        dayPickerWeekHeaderSmall: 14,
        hiddenInputFieldContainerHeight: 0,
        hiddenInputFieldContainerWidth: 0,
        invalidInputMixin: null,
        nextIcon: PaletteIconArrowRight,
        previousIcon: PaletteIconArrowLeft,
        singleDatePickerBorderColor: null,
        singleDatePickerLeftRight: 16,
        singleDatePickerPaddingTopBottom: 8,
        singleDatePickerRadius: 4,
        validInputMixin: null
      }
    },
    Divider: {
      appearances: {
        decorative: {
          description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
          type: 'variant',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        weight: { type: 'variant', values: [ 'thick' ] }
      },
      rules: [
        { if: { weight: 'thick' }, tokens: { width: 2 } },
        { if: { decorative: true }, tokens: { color: '#cdcfd5' } },
        { if: { inverse: true }, tokens: { color: '#ffffff' } }
      ],
      tokens: { color: '#9c9faa', width: 1 }
    },
    ExpandCollapseMini: { appearances: {}, rules: [], tokens: { borderWidth: 0 } },
    ExpandCollapseMiniControl: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [],
      tokens: { icon: null, size: 4 }
    },
    Feedback: {
      appearances: {
        icon: { type: 'variant', values: [ true ] },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success' ]
        }
      },
      rules: [
        {
          if: { validation: 'success' },
          tokens: { backgroundColor: '#eaf3f1', color: '#394056' }
        },
        {
          if: { validation: 'error' },
          tokens: { backgroundColor: '#f9e8e9', color: '#394056' }
        },
        {
          if: { icon: true, validation: 'success' },
          tokens: { icon: PaletteIconCheckMark, iconColor: '#2b826e' }
        },
        {
          if: { icon: true, validation: 'error' },
          tokens: { icon: PaletteIconError, iconColor: '#bf1722' }
        }
      ],
      tokens: {
        backgroundColor: '#f5f5f7',
        borderColor: null,
        borderRadius: 4,
        borderWidth: 0,
        color: '#394056',
        contentFontSize: 14,
        fontName: 'SofiaPro',
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconGap: 8,
        iconSize: 24,
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        space: 2,
        titleFontSize: 18
      }
    },
    Footnote: {
      appearances: {},
      rules: [],
      tokens: {
        closeButtonBorderColor: '#394056',
        closeButtonBorderSize: 1,
        closeButtonHeight: 24,
        closeButtonIconSize: 16,
        closeButtonMarginBottom: 4,
        closeButtonMarginLeft: 4,
        closeButtonMarginRight: 12,
        closeButtonMarginTop: 12,
        closeButtonWidth: 24,
        footnoteBackground: '#f9f2dd',
        footnoteBodyBackground: '#f9f2dd',
        footnoteBodyPaddingBottom: 32,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteBorderColorMd: '#cdcfd5',
        footnoteBorderTopSizeMd: 1,
        headerMargin: 16,
        listItemColor: '#f9f2dd',
        listItemFontSize: 14,
        listItemLineHeight: 1.428,
        listItemMarkerFontSize: 16,
        listItemMarkerLineHeight: 1.428,
        listItemPaddingLeft: 8,
        listPaddingLeft: 32
      }
    },
    FootnoteLink: {
      appearances: {},
      rules: [],
      tokens: { lineHeight: 1, paddingLeft: 2, paddingRight: 2 }
    },
    HorizontalScrollButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#636c8c',
        borderRadius: 48,
        borderWidth: 2,
        iconColor: '#636c8c',
        iconScale: 1,
        iconSize: 16,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 8,
        shadow: null
      }
    },
    Icon: {
      appearances: {
        color: {
          description: 'Use colour to change the colour',
          type: 'variant',
          values: [
            'brand',   'subtle',
            'offer',   'success',
            'danger',  'warning',
            'inverse'
          ]
        },
        size: {
          description: 'Use size to change the dimension of the icon',
          type: 'variant',
          values: [ 'micro', 'small', 'large', 'extraLarge' ]
        }
      },
      rules: [
        { if: { size: 'micro' }, tokens: { size: 16 } },
        { if: { size: 'small' }, tokens: { size: 20 } },
        { if: { size: 'large' }, tokens: { size: 32 } },
        { if: { size: 'extraLarge' }, tokens: { size: 48 } },
        { if: { color: 'brand' }, tokens: { color: '#394056' } },
        { if: { color: 'subtle' }, tokens: { color: '#6a7080' } },
        { if: { color: 'offer' }, tokens: { color: '#f39d80' } },
        { if: { color: 'success' }, tokens: { color: '#2b826e' } },
        { if: { color: 'danger' }, tokens: { color: '#bf1722' } },
        { if: { color: 'warning' }, tokens: { color: '#394056' } },
        { if: { color: 'inverse' }, tokens: { color: '#ffffff' } }
      ],
      tokens: { color: '#394056', size: 24 }
    },
    IconButton: {
      appearances: {
        compact: {
          description: 'Without the outer border gap',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'For use on dark backgrounds',
          type: 'variant',
          values: [ true ]
        },
        password: {
          description: 'password mask and unmask',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        },
        raised: {
          description: 'Uses shadow and background colour to appear raised above the page',
          type: 'variant',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'small', 'large' ] }
      },
      rules: [
        {
          if: { inverse: true },
          tokens: { borderColor: '#f9f2dd', iconColor: '#f9f2dd' }
        },
        {
          if: { hover: true },
          tokens: {
            borderColor: '#394056',
            iconColor: '#394056',
            iconScale: 1.1
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { borderColor: '#f9cebf', iconColor: '#f9cebf' }
        },
        {
          if: { hover: true, password: true },
          tokens: { backgroundColor: '#394056', iconColor: '#ffffff' }
        },
        {
          if: { password: true },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)' }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#636c8c',
            iconColor: '#636c8c',
            outerBorderColor: '#636c8c',
            outerBorderGap: 4,
            outerBorderWidth: 3
          }
        },
        {
          if: { focus: true, password: true },
          tokens: { borderColor: '#636c8c', borderWidth: 2 }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            borderColor: '#f9f2dd',
            iconColor: '#f9f2dd',
            outerBorderColor: '#f9f2dd',
            outerBorderWidth: 3
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#636c8c',
            borderColor: '#ffffff',
            iconColor: '#ffffff',
            outerBorderColor: '#636c8c',
            outerBorderGap: 4
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#f39d80',
            borderColor: '#394056',
            iconColor: '#394056',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 3
          }
        },
        {
          if: { size: 'large' },
          tokens: { iconSize: 24, padding: 12 }
        },
        { if: { size: 'small' }, tokens: { padding: 4 } },
        {
          description: 'Raised IconButtons follow different design patterns to other variants',
          if: { raised: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#636c8c',
            borderWidth: 3,
            outerBorderColor: 'transparent',
            outerBorderGap: 0,
            outerBorderWidth: 0,
            padding: 12,
            shadow: {
              blur: 2,
              color: 'rgba(0, 0, 0, 0.1)',
              inset: false,
              offsetX: 0,
              offsetY: 2,
              spread: 0
            }
          }
        },
        {
          if: { raised: true, size: 'large' },
          tokens: { padding: 16 }
        },
        { if: { raised: true, size: 'small' }, tokens: { padding: 8 } },
        {
          if: { pressed: true, raised: true },
          tokens: {
            backgroundColor: '#636c8c',
            borderColor: '#636c8c',
            borderWidth: 0,
            iconColor: '#ffffff',
            outerBorderColor: '#636c8c'
          }
        },
        {
          if: { focus: true, pressed: true, raised: true },
          tokens: {
            backgroundColor: '#636c8c',
            borderColor: '#636c8c',
            borderWidth: 0,
            iconColor: '#ffffff',
            outerBorderColor: '#636c8c'
          }
        },
        {
          if: { hover: true, pressed: false, raised: true },
          tokens: { borderColor: '#394056', borderWidth: 3 }
        },
        {
          if: { focus: true, pressed: false, raised: true },
          tokens: {
            borderColor: '#636c8c',
            borderWidth: 4,
            iconColor: '#636c8c'
          }
        },
        { if: { compact: true }, tokens: { outerBorderGap: 0 } },
        {
          if: { inactive: true, password: true },
          tokens: { iconColor: '#9c9faa', outerBorderWidth: 0 }
        },
        {
          if: { hover: true, inactive: true, password: true },
          tokens: { iconColor: '#9c9faa', outerBorderWidth: 0 }
        },
        { if: { password: true }, tokens: { outerBorderWidth: 0 } }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderColor: '#636c8c',
        borderRadius: 99999999999999,
        borderWidth: 3,
        iconColor: '#636c8c',
        iconScale: 1,
        iconSize: 24,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 8,
        shadow: null
      }
    },
    Image: { appearances: {}, rules: [], tokens: { borderRadius: 4 } },
    InputLabel: {
      appearances: {},
      rules: [],
      tokens: {
        color: '#394056',
        fontName: 'SofiaPro',
        fontSize: 18,
        fontWeight: '400',
        gap: 8,
        hintColor: '#394056',
        hintFontName: 'SofiaPro',
        hintFontSize: 14,
        hintFontWeight: '400',
        hintLineHeight: 1.428,
        lineHeight: 1.55555555
      }
    },
    InputSupports: { appearances: {}, rules: [], tokens: { space: 1 } },
    Link: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        iconPosition: {
          description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
          type: 'state',
          values: [ 'left', 'right' ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        },
        size: {
          description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
          type: 'variant',
          values: [ 'micro', 'small', 'large' ]
        }
      },
      rules: [
        { if: { iconPosition: 'left' }, tokens: { iconSpace: 2 } },
        {
          if: { focus: true },
          tokens: {
            color: '#636c8c',
            outerBorderColor: '#636c8c',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#2b3145', outerBorderColor: '#2b3145' }
        },
        {
          if: { hover: true },
          tokens: { color: '#394056', textLine: 'none' }
        },
        {
          if: { pressed: true },
          tokens: { color: '#2b3145', textLine: 'none' }
        },
        { if: { alternative: true }, tokens: { color: '#636c8c' } },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#636c8c', outerBorderColor: '#636c8c' }
        },
        {
          if: { alternative: true, focus: true, pressed: true },
          tokens: { color: '#2b3145', outerBorderColor: '#2b3145' }
        },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#394056' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#f39d80' }
        },
        { if: { inverse: true }, tokens: { color: '#f9f2dd' } },
        {
          if: { focus: true, inverse: true },
          tokens: { color: '#f9f2dd', outerBorderColor: '#f9f2dd' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { color: '#f39d80', outerBorderColor: '#f39d80' }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#f9cebf' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#f39d80' }
        },
        {
          if: { size: 'micro' },
          tokens: {
            blockFontName: 'SofiaPro',
            blockFontSize: 14,
            blockFontWeight: '400',
            blockLineHeight: 1.43,
            iconSize: 16
          }
        },
        {
          if: { size: 'small' },
          tokens: { blockFontSize: 16, blockLineHeight: 1.5, iconSize: 20 }
        },
        {
          if: { size: 'large' },
          tokens: { blockFontSize: 20, blockLineHeight: 1.428, iconSize: 24 }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        blockFontName: 'SofiaPro',
        blockFontSize: 18,
        blockFontWeight: '400',
        blockLineHeight: 1.56,
        borderRadius: 4,
        color: '#636c8c',
        icon: null,
        iconSize: 24,
        iconSpace: 1,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderOutline: 'none',
        outerBorderWidth: 2,
        textLine: 'underline',
        textLineStyle: 'solid'
      }
    },
    Modal: {
      appearances: {
        maxWidth: {
          description: 'Whether a modal should expand responsively to the maximum of 8 layout columns width',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'The width of the modal',
          type: 'state',
          values: [ 's', 'm', 'l', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            height: '100%',
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 576
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 's' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 320
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 'm' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 480
          }
        },
        {
          if: { viewport: [ 'lg', 'xl' ], width: 'l' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 630
          }
        },
        {
          if: { viewport: 'xl', width: 'xl' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 768
          }
        },
        {
          if: { maxWidth: true, viewport: 'md' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 480
          }
        },
        {
          if: { maxWidth: true, viewport: 'lg' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 630
          }
        },
        {
          if: { maxWidth: true, viewport: 'xl' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 768
          }
        }
      ],
      tokens: {
        backdropColor: '#fefefc',
        backdropOpacity: 1,
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        borderRadius: 4,
        cancelButtonColor: '#394056',
        closeIcon: PaletteIconClose,
        closeIconSize: 16,
        closePadding: 4,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        gap: 16,
        headingColor: '#394056',
        headingPaddingRight: 24,
        height: null,
        marginLeft: 24,
        marginRight: 24,
        maxWidth: '100%',
        paddingBottom: 24,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 24,
        shadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        subHeadingMarginTop: 8
      }
    },
    Notification: {
      appearances: {
        style: { type: 'state', values: [ 'success', 'warning', 'error' ] },
        system: { type: 'state', values: [ true ] }
      },
      rules: [
        {
          if: { system: true },
          tokens: {
            borderLeftWidth: 0,
            borderRadius: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 12,
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        },
        {
          if: { style: 'success' },
          tokens: {
            backgroundColor: '#eaf3f1',
            borderColor: '#eaf3f1',
            icon: PaletteIconCheckMark,
            iconColor: '#2b826e'
          }
        },
        {
          if: { style: 'warning' },
          tokens: {
            backgroundColor: '#fcf8ee',
            borderColor: '#fcf8ee',
            dismissIcon: null,
            icon: PaletteIconWarningError,
            iconColor: '#6a7080'
          }
        },
        {
          if: { style: 'error' },
          tokens: {
            backgroundColor: '#f9e8e9',
            borderColor: '#f9e8e9',
            dismissIcon: null,
            icon: PaletteIconWarningError,
            iconColor: '#bf1722'
          }
        }
      ],
      tokens: {
        backgroundColor: '#f5f5f7',
        borderBottomWidth: 1,
        borderColor: '#f5f5f7',
        borderLeftWidth: 1,
        borderRadius: 4,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: '#394056',
        dismissButtonGap: 16,
        dismissIcon: PaletteIconMobileXClose,
        dismissIconColor: '#394056',
        dismissIconSize: 24,
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '700',
        icon: null,
        iconColor: null,
        iconGap: 16,
        iconSize: 24,
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12
      }
    },
    OrderedList: {
      appearances: {
        compact: {
          description: 'When true it will reduce the line height of the list item.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Indicates list item text size.',
          type: 'variant',
          values: [ 'large', 'medium', 'small' ]
        }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: { itemFontSize: 20, itemLineHeight: 1.43 }
        },
        { if: { size: 'medium' }, tokens: {} },
        {
          if: { size: 'small' },
          tokens: { itemFontSize: 16, itemLineHeight: 1.5 }
        },
        { if: { compact: true }, tokens: {} },
        { if: { compact: true, size: 'medium' }, tokens: {} },
        { if: { compact: true, size: 'large' }, tokens: {} }
      ],
      tokens: {
        headerFontName: 'SofiaPro',
        headerFontWeight: '700',
        itemBulletContainerWidth: 16,
        itemColor: '#394056',
        itemFontName: 'SofiaPro',
        itemFontSize: 18,
        itemFontWeight: '400',
        itemLineHeight: 1.55555555,
        listGutter: 8
      }
    },
    PreviewCard: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        }
      },
      rules: [],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        borderRadius: 0,
        borderWidth: 1,
        flex: 1,
        outerBorderColor: '#ffffff',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        separatorColor: null
      }
    },
    PriceLockup: {
      appearances: {},
      rules: [],
      tokens: {
        bottomLinksMarginLeft: 4,
        bottomTextMarginTop: 4,
        dividerColor: '#9c9faa',
        fontColor: '#394056',
        footnoteGap: 4,
        footnoteMarginTop: 4,
        priceMarginBottom: 8,
        strikeThroughBackground: '#2b826e',
        strikeThroughHeight: 2,
        topTextMarginBottom: 4
      }
    },
    Progress: {
      appearances: { size: { type: 'variant', values: [ 'mini' ] } },
      rules: [ { if: { size: 'mini' }, tokens: { height: 8 } } ],
      tokens: {
        backgroundColor: '#f5f5f7',
        borderColor: '#9c9faa',
        borderRadius: 12,
        borderWidth: 1,
        height: 16
      }
    },
    ProgressBar: {
      appearances: {
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        negative: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { inactive: true },
          tokens: { backgroundColor: '#cdcfd5' }
        },
        {
          if: { negative: true },
          tokens: { backgroundColor: '#bf1722' }
        }
      ],
      tokens: {
        backgroundColor: '#2b826e',
        borderRadius: 12,
        gradient: null,
        outlineColor: '#394056',
        outlineWidth: 1
      }
    },
    QuickLinks: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { card: false, dividers: true, list: false }
        }
      ],
      tokens: {
        card: true,
        dividers: true,
        list: true,
        stackGap: 2,
        stackJustify: 'center',
        stackSpace: 5
      }
    },
    QuickLinksButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#cdcfd5',
            borderColor: '#9c9faa',
            borderWidth: 3,
            color: '#9c9faa',
            iconColor: '#9c9faa'
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#394056' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderWidth: 1, outerBorderColor: '#9c9faa' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#f9f2dd',
        borderColor: '#394056',
        borderRadius: 48,
        borderWidth: 1,
        color: '#394056',
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '700',
        icon: null,
        iconColor: '#394056',
        iconSize: 24,
        iconSpace: 2,
        lineHeight: 1.5,
        minWidth: 112,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        width: null
      }
    },
    QuickLinksCard: {
      appearances: {},
      rules: [],
      tokens: {
        backgroundColor: '#f9f2dd',
        borderColor: '#394056',
        borderRadius: 8,
        borderWidth: 1,
        flex: 1,
        minWidth: null,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        shadow: null
      }
    },
    QuickLinksList: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#fce6df' } },
        { if: { focus: true }, tokens: { backgroundColor: '#f9cebf' } },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#9c9faa',
            itemFontColor: '#6a7080',
            itemIconColor: '#6a7080'
          }
        }
      ],
      tokens: {
        backgroundColor: '#f9f2dd',
        dividerColor: '#9c9faa',
        dividerSize: 1,
        iconMarginTop: 0,
        interItemMargin: 0,
        interItemMarginWithDivider: 0,
        itemBulletColor: 'rgba(0, 0, 0, 0)',
        itemBulletContainerAlign: 'center',
        itemBulletContainerWidth: 0,
        itemBulletHeight: 0,
        itemBulletWidth: 0,
        itemFontColor: '#394056',
        itemFontName: 'SofiaPro',
        itemFontSize: 16,
        itemFontWeight: '700',
        itemIconColor: '#394056',
        itemIconSize: 24,
        itemLineHeight: 1.5,
        listGutter: 16,
        paddingBottom: 12,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 12
      }
    },
    Radio: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { error: true }, tokens: {} },
        {
          if: { hover: true },
          tokens: {
            inputBackgroundColor: '#fce6df',
            inputBorderColor: '#9c9faa',
            inputOutlineColor: '#cdcfd5',
            inputOutlineWidth: 2
          }
        },
        {
          if: { checked: true, hover: true },
          tokens: { inputBorderColor: '#394056' }
        },
        {
          if: { focus: true },
          tokens: { inputBorderColor: '#f39d80', inputBorderWidth: 3 }
        },
        {
          if: { inactive: true },
          tokens: {
            checkedBackgroundColor: '#cdcfd5',
            inputBackgroundColor: '#cdcfd5',
            inputBorderColor: '#9c9faa',
            labelColor: '#6a7080'
          }
        },
        {
          if: { checked: true, inactive: true },
          tokens: { checkedBackgroundColor: '#9c9faa' }
        }
      ],
      tokens: {
        checkedBackgroundColor: '#394056',
        checkedSize: 12,
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        containerBorderRadius: 0,
        containerOpacity: 1,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        containerShadow: null,
        descriptionFontSize: 16,
        descriptionLineHeight: 1.5,
        descriptionMarginLeft: null,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#394056',
        inputBorderWidth: 2,
        inputOutlineColor: 'rgba(0, 0, 0, 0)',
        inputOutlineWidth: 0,
        inputSize: 20,
        labelColor: '#394056',
        labelFontName: 'SofiaPro',
        labelFontSize: 18,
        labelFontWeight: '400',
        labelLineHeight: 1.55555555,
        labelMarginLeft: 10,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0
      }
    },
    RadioGroup: { appearances: {}, rules: [], tokens: { fieldSpace: 2, space: 2 } },
    Ribbon: {
      appearances: {
        purpose: {
          type: 'variant',
          values: [ 'offer', 'default', 'editorial' ]
        }
      },
      rules: [],
      tokens: {
        backgroundColor: '#f39d80',
        borderRadius: 4,
        boxShadowColor: '#f39d80',
        boxShadowPaddingBottom: 2,
        boxShadowPaddingLeft: 2,
        boxShadowPaddingRight: 2,
        boxShadowPaddingTop: 2,
        curveAfterBackgroundColor: '#f39d80',
        curveAfterHeight: 4,
        curveAfterRadius: 8,
        curveAfterWidth: 8,
        curveBackgroundColor: '#f39d80',
        curveHeight: 10,
        curveMarginTop: 4,
        curveWidth: 8,
        gradient: null,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4
      }
    },
    Select: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { outerBorderColor: '#cdcfd5' }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#f39d80', outerBorderWidth: 3 }
        },
        {
          if: { validation: 'success' },
          tokens: {
            borderColor: '#2b826e',
            validationIcon: PaletteIconCheckMark,
            validationIconColor: '#2b826e'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            borderColor: '#bf1722',
            validationIcon: PaletteIconInfo,
            validationIconColor: '#bf1722'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#cdcfd5',
            borderColor: '#cdcfd5',
            color: '#9c9faa',
            icon: null
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#394056',
        borderRadius: 4,
        borderWidth: 1,
        color: '#394056',
        fontName: 'SofiaPro',
        fontSize: 18,
        fontWeight: '400',
        height: 48,
        icon: PaletteIconChevronDown,
        iconColor: '#394056',
        iconSize: 24,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 2,
        paddingBottom: 10,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 10,
        validationIcon: null,
        validationIconColor: 'rgba(0, 0, 0, 0)',
        validationIconSize: 24
      }
    },
    Spinner: {
      appearances: { size: { type: 'variant', values: [ 'small' ] } },
      rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 4 } } ],
      tokens: {
        fullScreenOverLayBackground: '#9c9faa',
        size: 48,
        thickness: 4
      }
    },
    StackView: {
      appearances: {},
      rules: [],
      tokens: {
        alignItems: 'stretch',
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start'
      }
    },
    Table: {
      appearances: { spacing: { type: 'variant', values: [ 'compact' ] } },
      rules: [
        {
          if: { spacing: 'compact' },
          tokens: { cellPaddingBottom: 8, cellPaddingTop: 8 }
        }
      ],
      tokens: {
        cellBackground: '#ffffff',
        cellBoxShadowColor: '#fce6df',
        cellHeadingBackground: '#fce6df',
        cellHeadingBoxShadowColor: '#fce6df',
        cellPaddingBottom: 16,
        cellPaddingLeft: 16,
        cellPaddingRight: 16,
        cellPaddingTop: 16,
        cellRowHeadingBackground: '#ffffff',
        cellStickyShadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        cellSubheadingBackground: '#fce6df',
        tablePaddingBottom: 24
      }
    },
    Tabs: {
      appearances: {
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { inverse: true },
          tokens: { borderBottomColor: '#f9f2dd' }
        }
      ],
      tokens: {
        borderBottomColor: '#394056',
        borderBottomWidth: 1,
        buttonClearance: 32,
        gutter: null,
        nextIcon: PaletteIconChevronRight,
        previousIcon: PaletteIconChevronLeft,
        space: 0
      }
    },
    TabsItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        },
        selected: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { selected: true },
          tokens: {
            color: '#394056',
            highlightBarBorderWidth: 4,
            highlightBarHeight: 1,
            highlightColor: '#f39d80'
          }
        },
        { if: { hover: true }, tokens: { color: '#636c8c' } },
        {
          if: { focus: true },
          tokens: { borderColor: '#394056', borderWidth: 1, color: '#394056' }
        },
        {
          if: { pressed: true },
          tokens: { borderWidth: 0, color: '#2b3145' }
        },
        {
          if: { inverse: true },
          tokens: { backgroundColor: 'transparent', color: '#f9f2dd' }
        },
        {
          if: { inverse: true, selected: true },
          tokens: {
            color: '#f9f2dd',
            highlightBarBorderWidth: 4,
            highlightBarHeight: 1,
            highlightColor: '#f9f2dd'
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#f9cebf' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { borderColor: '#f9f2dd', color: '#f9f2dd' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#f39d80' }
        }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderRadius: 0,
        borderWidth: 0,
        color: '#394056',
        fontName: 'SofiaPro',
        fontScaleCap: 64,
        fontSize: 16,
        fontWeight: '700',
        highlightBarBorderRadius: 0,
        highlightBarBorderWidth: 0,
        highlightBarHeight: 0,
        highlightColor: 'transparent',
        highlightTriangleSize: 0,
        letterSpacing: 0,
        lineHeight: 1.5,
        maxWidth: null,
        paddingHorizontal: 24,
        paddingVertical: 12,
        space: 0,
        textAlign: 'center',
        textTransform: 'none'
      }
    },
    TextArea: {
      appearances: {},
      rules: [],
      tokens: { maxLines: 8, minLines: 5 }
    },
    TextInput: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        password: {
          description: 'password mask and unmask',
          type: 'variant',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success' ]
        }
      },
      rules: [
        {
          if: { hover: true, inactive: null },
          tokens: {
            outerBackgroundColor: '#cdcfd5',
            outerBorderColor: '#cdcfd5',
            outerBorderWidth: 1
          }
        },
        {
          if: { validation: 'success' },
          tokens: {
            borderColor: '#2b826e',
            icon: PaletteIconCheckMark,
            iconColor: '#2b826e'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            borderColor: '#bf1722',
            icon: PaletteIconXMark,
            iconColor: '#bf1722'
          }
        },
        {
          if: { focus: true },
          tokens: {
            icon: null,
            outerBackgroundColor: '#f39d80',
            outerBorderColor: '#f39d80',
            outerBorderWidth: 2
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#cdcfd5',
            borderColor: '#cdcfd5',
            color: '#9c9faa'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#394056',
        borderRadius: 4,
        borderWidth: 1,
        buttonSize: 40,
        buttonsGap: 1,
        buttonsPaddingRight: 10,
        clearButtonIcon: PaletteIconEyeUnmasked,
        color: '#394056',
        fontName: 'SofiaPro',
        fontSize: 18,
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconSize: 24,
        lineHeight: 1.5,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 2,
        paddingBottom: 14,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        passwordHideButtonIcon: PaletteIconEyeMasked,
        passwordShowButtonIcon: PaletteIconEyeUnmasked
      }
    },
    Toast: {
      appearances: {},
      rules: [],
      tokens: {
        animationBackgroundColorAfter: '#ffffff',
        animationBackgroundColorBefore: '#ffffff',
        animationColorAfter: '#394056',
        animationColorBefore: '#ffffff',
        animationDivColorAfter: '#ffffff',
        animationDivColorBefore: '#ffffff',
        animationFillColorAfter: '#ffffff',
        animationFillColorBefore: '#ffffff',
        animationHeightAfter: 24,
        animationHeightBefore: 0,
        animationPaddingBottomAfter: 16,
        animationPaddingBottomBefore: 0,
        animationPaddingTopAfter: 16,
        animationPaddingTopBefore: 0,
        containerBackgroundColor: '#ffffff',
        containerGap: 12
      }
    },
    Tooltip: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [
        {
          if: { inverse: true },
          tokens: { backgroundColor: '#ffffff', color: '#394056' }
        }
      ],
      tokens: {
        arrowBorderRadius: 0,
        arrowOffset: 4,
        arrowWidth: 16,
        backgroundColor: '#394056',
        borderRadius: 8,
        color: '#fefefc',
        fontName: 'SofiaPro',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 1.5,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        shadow: {
          blur: 0,
          color: 'rgba(0, 0, 0, 0)',
          inset: false,
          offsetX: 0,
          offsetY: 0,
          spread: 0
        }
      }
    },
    TooltipButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn' ],
          type: 'state',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { inverse: true }, tokens: { iconColor: '#f5f5f7' } },
        { if: { hover: true }, tokens: { iconScale: 1.25 } },
        { if: { pressed: true }, tokens: { iconColor: '#6a7080' } },
        {
          if: { inverse: true, pressed: true },
          tokens: { iconColor: '#f5f5f7' }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#f39d80' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { iconColor: '#f5f5f7', outerBorderColor: '#cdcfd5' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { iconColor: '#cdcfd5', outerBorderColor: '#cdcfd5' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { iconColor: '#6a7080', outerBorderColor: '#6a7080' }
        }
      ],
      tokens: {
        borderRadius: 8,
        icon: PaletteIconHelp,
        iconColor: '#394056',
        iconScale: 1,
        iconSize: 16,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 4,
        outerBorderWidth: 2,
        width: 16
      }
    },
    Typography: {
      appearances: {
        bold: {
          description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
          type: 'variant',
          values: [ true ]
        },
        colour: {
          description: 'Each typography variant has a default color, and at least a secondary color variant. In exceptional cases where a different colour is needed,\n' +
            '  use the tokens prop.',
          type: 'variant',
          values: [ 'secondary', 'tertiary' ]
        },
        compact: {
          description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
          type: 'variant',
          values: [ true ]
        },
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          type: 'variant',
          values: [
            'micro',    'small',
            'large',    'h1',
            'h2',       'h3',
            'h4',       'h5',
            'h6',       'display1',
            'display2', 'eyebrow'
          ]
        },
        weight: {
          description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
          type: 'variant',
          values: [ 'semibold', 'bold' ]
        }
      },
      rules: [
        {
          if: { compact: true, size: 'large' },
          tokens: { lineHeight: 1.2 }
        },
        {
          description: "The compact line height for the 'default' font size, but doesn't apply for any other styles",
          if: { compact: true, size: null },
          tokens: { lineHeight: 1.25 }
        },
        {
          if: { compact: true, size: 'small' },
          tokens: { lineHeight: 1.14285714286 }
        },
        { if: { colour: 'secondary' }, tokens: { color: '#f39d80' } },
        { if: { colour: 'tertiary' }, tokens: { color: '#2b3145' } },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          description: 'Please only bold single words while using with headings',
          if: {
            bold: true,
            viewport: [ 'h1', 'h2', 'display1', 'display2' ]
          },
          tokens: { fontName: 'BystanderSans', fontWeight: '700' }
        },
        {
          description: 'Please only bold single words while using with headings',
          if: {
            bold: true,
            viewport: [
              'micro', 'small',
              'large', 'h3',
              'h4',    'h5',
              'h6'
            ]
          },
          tokens: { fontName: 'SofiaPro', fontWeight: '700' }
        },
        {
          if: { size: 'display1' },
          tokens: {
            fontName: 'BystanderSans',
            fontSize: 72,
            fontWeight: '700'
          }
        },
        {
          if: { size: 'display2' },
          tokens: {
            fontName: 'BystanderSans',
            fontSize: 64,
            fontWeight: '700'
          }
        },
        { if: { size: 'large' }, tokens: { fontSize: 20 } },
        {
          if: { size: 'eyebrow' },
          tokens: {
            fontName: 'SofiaPro',
            fontSize: 14,
            fontWeight: '700',
            lineHeight: 1.28571428571,
            textTransform: 'uppercase'
          }
        },
        { if: { size: 'small' }, tokens: { fontSize: 16 } },
        { if: { size: 'micro' }, tokens: { fontSize: 14 } },
        {
          if: { size: 'h1' },
          tokens: {
            fontName: 'BystanderSans',
            fontSize: 48,
            fontWeight: '700'
          }
        },
        {
          if: { size: 'h2' },
          tokens: {
            fontName: 'BystanderSans',
            fontSize: 36,
            fontWeight: '700'
          }
        },
        {
          if: { size: 'h3' },
          tokens: { fontName: 'SofiaPro', fontSize: 30, fontWeight: '700' }
        },
        {
          if: { size: 'h4' },
          tokens: { fontName: 'SofiaPro', fontSize: 24, fontWeight: '700' }
        },
        {
          if: { size: 'h5' },
          tokens: { fontName: 'SofiaPro', fontSize: 20, fontWeight: '700' }
        },
        {
          if: { size: 'h6' },
          tokens: { fontName: 'SofiaPro', fontWeight: '700' }
        },
        {
          if: { weight: 'semibold' },
          tokens: { fontName: 'SofiaPro', fontWeight: '700' }
        },
        {
          if: { weight: 'bold' },
          tokens: { fontName: 'SofiaPro', fontWeight: '700' }
        }
      ],
      tokens: {
        color: '#394056',
        fontName: 'SofiaPro',
        fontScaleCap: 64,
        fontSize: 16,
        fontWeight: '400',
        letterSpacing: 0,
        lineHeight: 1.2,
        textTransform: 'none'
      }
    },
    WaffleGrid: {
      appearances: {},
      rules: [],
      tokens: {
        itemBorderColor: 'rgba(0, 0, 0, 0)',
        itemPadding: 16,
        rowBorderWidth: 1
      }
    },
    spacingScale: {
      appearances: {
        space: {
          description: 'Index of the intended position on the spacing scale',
          type: 'state',
          values: [
             0, 1, 2, 3,  4,  5,
             6, 7, 8, 9, 10, 11,
            12
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { viewport: [ 'lg', 'xl' ] }, tokens: { size: 112 } },
        { if: { space: 11 }, tokens: { size: 80 } },
        { if: { space: 12 }, tokens: { size: 112 } },
        { if: { space: 10 }, tokens: { size: 64 } },
        { if: { space: 9 }, tokens: { size: 56 } },
        { if: { space: 8 }, tokens: { size: 48 } },
        { if: { space: 7 }, tokens: { size: 40 } },
        { if: { space: 6 }, tokens: { size: 32 } },
        { if: { space: 5 }, tokens: { size: 24 } },
        { if: { space: 4 }, tokens: { size: 16 } },
        { if: { space: 3 }, tokens: { size: 12 } },
        { if: { space: 2 }, tokens: { size: 8 } },
        { if: { space: 1 }, tokens: { size: 4 } },
        { if: { space: 0 }, tokens: { size: 0 } }
      ],
      tokens: { size: 80 }
    }
  },
  metadata: {
    name: 'themes-community.theme-public-mobile-rebrand',
    themeTokensVersion: '2.21.0'
  }
}
